import React from 'react'
import {_} from 'plugins/i18n'
import {CardOrAccordion} from '../Components'
import Text from 'app/Components/twComponents/Text'
import {COND_BRINGOWN, COND_INCLUDED} from 'app/_server/database/constants'
import {CircledCheck} from 'app/Components/Icon'
import {useReservationFormState} from '../hooks'
import {BaseCostsPanel, OverviewPanel} from './Components'

const ReservationSummary = () => {
	const {formValue} = useReservationFormState()
	const {contract} = formValue || {}
	const {options} = contract || {}

	const extrasIncluded = options.filter(
		({condition}) => condition === COND_INCLUDED
	)
	const extrasBringOwn = options.filter(
		({condition}) => condition === COND_BRINGOWN
	)

	return (
		<div className="border-silver flex flex-col rounded-lg border border-solid lg:gap-6 lg:border-none">
			<CardOrAccordion title="CostsLabel" isOpenInit>
				<BaseCostsPanel contract={contract} />
			</CardOrAccordion>

			{extrasIncluded?.length ? (
				<CardOrAccordion title="IncludedLabel">
					<ul className="flex flex-col gap-2">
						{extrasIncluded.map(({optionId}, i) => (
							<li key={i} className="flex items-center gap-2">
								<CircledCheck />
								<Text variant="base">{_(optionId)}</Text>
							</li>
						))}
					</ul>
				</CardOrAccordion>
			) : null}

			{extrasBringOwn?.length ? (
				<CardOrAccordion title="BringOwnLabel">
					<ul className="flex flex-col gap-2">
						{extrasBringOwn.map(({optionId}, i) => (
							<li key={i} className="flex items-center gap-2">
								<CircledCheck />
								<Text variant="base">{_(optionId)}</Text>
							</li>
						))}
					</ul>
				</CardOrAccordion>
			) : null}

			<CardOrAccordion
				title="CostOverviewLabel"
				classNameInner="flex flex-col gap-4 pt-3"
			>
				<OverviewPanel contract={contract} />
			</CardOrAccordion>
		</div>
	)
}

export default ReservationSummary
